import Chart, { useChart } from "src/components/chart";
import { alpha, useTheme } from "@mui/material/styles";
import { fPercent } from "src/utils/format-number";
import "./style.scss";
import styled from "@emotion/styled";

interface Props {
    options?: ApexCharts.ApexOptions;
    series?: {
        name: string;
        data: number[];
        color?: string;
    }[];
}

const HEIGHT = 55;

export default function ColumnStackVertical({ options = {}, series = [] }: Props) {
    const colors = ["#18A155", "#BC9510", '#F5CE47'];
    const theme = useTheme();

    const annotations: PointAnnotations[] = [];
    
    series.forEach((item, index) => {
        const offsetX = series.slice(0, index).reduce((acc, curr) => acc + curr.data[0], 0);
        const prevOffsetX = index !== 0 ? annotations[index - 1].x as number : 0;
        const opts = {
            x: offsetX,
            y: 0,
            marker: {
                size: 0,
            },
            label: {
                offsetY: 0,
                borderColor: alpha(theme.palette.background.paper, 0),
                text: fPercent(item.data[0]),
                style: {
                    background: alpha(theme.palette.background.paper, 0),
                    color: item.color
                }
            }
        }

        if (index === 0) {
            opts.x = 0;
            return annotations.push(opts)
        }

        if (prevOffsetX + 40 > opts.x) {
            opts.x = prevOffsetX + 20;
        }

        annotations.push(opts)
    })

    const chartOptions = useChart({
        chart: {
            type: "bar",
            stacked: true,
            stackType: '100%',
            offsetX: -15,
            width: '100%',
            height: "50px"
        },
        plotOptions: {
            bar: {
                barHeight: '7%',
                borderRadius: 1.5,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                horizontal: true,
            },
        },
        xaxis: {
            labels: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            },
        },
        tooltip: {
            enabled: false,
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        annotations: {
            points: annotations
        },
        yaxis: {
            show: false,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            }
        },
        colors: colors,
        ...options
    });

    return <Chart height={HEIGHT} type="bar" series={series} options={chartOptions} />
}